import { ApolloProvider } from '@apollo/client/react'
import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { createApolloClient } from './lib/apollo.js'
import { router } from './router.js'
import './index.css'

const container = document.getElementById('root')
if (!container) throw new Error('Missing #root')

/** One client, handed to both React and the router, as in the product app. */
const client = createApolloClient()

createRoot(container).render(
  <StrictMode>
    <ApolloProvider client={client}>
      <RouterProvider router={router} context={{ client }} />
    </ApolloProvider>
  </StrictMode>,
)
